<ng-container [ngSwitch]="true">
    <!--all chat-->
    <div *ngSwitchCase="role !=ProjectRole.ITLegalChat && role != ProjectRole.patentBot && role !=ProjectRole.theMind">
        <div class="h1 text-4xl font-semibold mt-6 sm:mt-[20vh] sm:mb-16 flex gap-2">
            Hello, I’m {{projectData?.title!}}
        </div>
        <div >
            <p class="fmessage-p">
              It's AI time! Here it is safe to ask and chat about anything related to your line of work.
            </p>
            <p class="fmessage-p text-center">Join the future!</p>
        </div>
    </div>

    <!--Patent Chat-->
    <div *ngSwitchCase="role ==ProjectRole.patentBot" >
        <div class="h1 text-4xl font-semibold mt-6 sm:mt-[20vh] sm:mb-16 flex gap-2">
            Hello, I’m {{projectData?.title!}}
        </div>
        <div class="fmessage-patent">
            <br> <br>
            <p><b> What can you do here?​</b></p>
            <p><b> 1. Draft a patent idea -</b>  answer the questions to develop your idea and obtain an idea for a query to Questel.</p>
            <p><b> 2. Upload the table of relevant patents</b> from Questel and<b> receive freedom to operate</b> report for your proposed patent.​</p>
        </div>

    </div>

    <!-- IT Legal Chat-->
    <div *ngSwitchCase="role==ProjectRole.ITLegalChat" class="hebrew-font">
        <div class=" text-he text-4xl font-semibold mt-6 sm:mt-[20vh] sm:mb-16 flex gap-2">
            ברוכים לצ'אט מסמכים משפטיים של IT
          </div>
          <div *ngIf="role==ProjectRole.ITLegalChat" class="fmessage-patent">
            ניתן לשאול שאלות בנוגע לכתב ההגנה, כתב התביעה, תצהירים  וחוות דעת המומחים הנוגעים לתיק המשפטי 
          </div>
    </div>

  <div *ngSwitchCase="role==ProjectRole.theMind" class="hebrew-font description-mind">
    <div class=" text-he text-4xl font-semibold mt-6 sm:mt-[20vh] sm:mb-16 flex gap-2">
      ברוכים הבאים לצ'אט היוזמות של חטיבת האשלג – THE MIND! </div>
    <div class="fmessage-tm fmessage-patent">
      <br> <br>
      <p><b> הדרך המהירה להפוך רעיון חדש להצעה מגובשת</b></p>
      <div>
        <ul>
          <li>להגדיר ולחדד את הרעיון</li>
          <li>להעשיר אותו בתובנות חדשות</li>
          <li>ולבסוף ליצור דוח מסכם הכולל:</li>
          <ul>
            <li>תמצית הרעיון</li>
            <li>הפניה לרעיונות דומים</li>
            <li>ניתוח סיכונים והזדמנויות</li>
            <li>המלצות להמשך</li>
          </ul>
        </ul>
      </div>
      <div class="info">
        <span class="span-list"><img class="custom-icon" src="../../../../assets/images/icons8-info-32.png"/> <span class="highlight">מידע חשוב:</span></span>
        <span class="span-list"> <img class="custom-icon" src="../../../../assets/images/output-onlinegiftool.gif"/>מדובר בפיילוט – נשמח למשוב!</span>
        <span class="span-list"><img class="custom-icon" src="../../../../assets/images/presise.gif"/> ככל שתשתף יותר פרטים, כך נוכל להציע תובנות מדויקות יותר.</span>
        <span class="span-list"><img class="custom-icon" src="../../../../assets/images/check.gif" /> חושב שסיפקת מספיק מידע? לחץ על הפקת הדוח כדי לעבור לשלב הבא.</span>
        <span class="span-list"><img class="custom-icon" src="../../../../assets/images/lock.gif" /> לצ'אט אין גישה לפרויקטים אחרים – הם יוצגו רק בדוח.</span>
      </div>
    </div>
  </div>
  <!-- 
     <div class=" text-he text-4xl font-semibold mt-6 sm:mt-[20vh] sm:mb-16 flex gap-2">
            ברוכים הבאים לצאט היוזמות של חטיבת אשלג THE MIND
          </div>
          <div class="fmessage-patent">
            <br> <br>
            <p><b>במה נוכל לעזור לך?</b></p>
            <p><b> 1. </b> הצאט יעזור לך לנסח רעיון חדש </p>
            <p><b> 2. </b>בסוף השיחה תוכל לקבל דוח שמסכם את הרעיון </p>
          </div>
    </div>
     -->
</ng-container>